import type { ListAllPaymentsItem } from "@albertine/types/openapi";
import { Lib } from "albertine-shared-web";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import routes from "../../utils/routes";
import Label from "../Common/Label";
import { List } from "../Common/List";
import {
    formatPaymentAmount,
    formatPaymentMethodLabel,
    formatPaymentStatusLabel,
} from "./paymentsList.util";

function paymentDescription(row: ListAllPaymentsItem): string {
    const details = row.otherDetails?.trim();
    if (details) {
        return details;
    }
    return "Payment request";
}

export function PaymentRowContent(props: { row: ListAllPaymentsItem }) {
    const { row } = props;
    const description = paymentDescription(row);
    const methodLabel = formatPaymentMethodLabel(row.paymentMethod);
    const createdByName = row.createdByName ?? "—";
    const statusLabel = formatPaymentStatusLabel(row.status);

    return (
        <>
            <List.ItemColumn className="w-[28%] min-w-0 shrink self-center pr-2 max-md:w-full">
                <Lib.Flex.Column gap="value4" className="w-full min-w-0">
                    <span
                        className="block min-w-0 max-w-full truncate"
                        title={description}
                    >
                        <Label.Medium.Light>{description}</Label.Medium.Light>
                    </span>
                    <Label.Small.Light.N50>
                        {new Date(row.createdAt).toLocaleDateString("en-GB", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                        })}
                    </Label.Small.Light.N50>
                </Lib.Flex.Column>
            </List.ItemColumn>
            <List.ItemColumn className="w-[10%] min-w-0 shrink self-center pr-2">
                <Label.Medium.Light className="block min-w-0 max-w-full truncate">
                    {formatPaymentAmount(row.amount)}
                </Label.Medium.Light>
            </List.ItemColumn>
            <List.ItemColumn className="w-[10%] min-w-0 shrink self-center pr-2 max-md:hidden">
                <Label.Medium.Light className="block min-w-0 max-w-full truncate">
                    {row.currency}
                </Label.Medium.Light>
            </List.ItemColumn>
            <List.ItemColumn className="w-[14%] min-w-0 shrink self-center pr-2 max-md:hidden">
                <span className="block min-w-0 max-w-full truncate" title={methodLabel}>
                    <Label.Medium.Light>{methodLabel}</Label.Medium.Light>
                </span>
            </List.ItemColumn>
            <List.ItemColumn className="w-[18%] min-w-0 shrink self-center pr-2 max-md:hidden">
                <span
                    className="block min-w-0 max-w-full truncate"
                    title={createdByName}
                >
                    <Label.Medium.Light>{createdByName}</Label.Medium.Light>
                </span>
            </List.ItemColumn>
            <List.ItemColumn className="w-[20%] min-w-0 shrink self-center max-md:hidden">
                <span className="block min-w-0 max-w-full truncate" title={statusLabel}>
                    <Label.Medium.Light>{statusLabel}</Label.Medium.Light>
                </span>
            </List.ItemColumn>
        </>
    );
}

export function PaymentRow(props: { row: ListAllPaymentsItem }) {
    const { row } = props;

    if (row.requestId !== null) {
        return (
            <NavLink to={routes.request(row.requestId as string)} className="list-item">
                <PaymentRowContent row={row} />
            </NavLink>
        );
    }

    return (
        <div
            className={classNames(
                "list-item",
                "cursor-default opacity-55 hover:cursor-default hover:bg-[color:var(--a-ds-surface-high)] hover:shadow-none",
            )}
        >
            <PaymentRowContent row={row} />
        </div>
    );
}
